import { useCallback } from 'react'

import { create } from '@bufbuild/protobuf'
import { useQuery } from '@connectrpc/connect-query'
import { previewBiddingIntradayOrderFeeAdjustedPrices } from '@ebalance/proto/bffuser/v1/bidding_intraday_service-BiddingIntradayService_connectquery'
import { PreviewBiddingIntradayOrderFeeAdjustedPricesRequestSchema } from '@ebalance/proto/bffuser/v1/bidding_intraday_service_pb'

import {
  type IntradayFeeState,
  resolveIntradayFeeState,
} from '~/pages/IntradayBidding/models/feeAutoConsider'

/** 画面が取得している手数料自動考慮 (時間前) の状態と、 その取り直し。 */
export type IntradayFeeStateHandle = {
  state: IntradayFeeState
  refetch: () => void
}

/**
 * 手数料自動考慮 (時間前) の状態を、 作成・編集モーダルを開く前から画面が取得しておく (AC-BIN-004b)。
 * モーダルは開いた時にこの状態を読み、 取得できていなければ応答を待たずに OFF として扱う。
 */
export function useIntradayFeeState(): IntradayFeeStateHandle {
  const { data, isPending, isError, failureCount, refetch } = useQuery(
    previewBiddingIntradayOrderFeeAdjustedPrices,
    create(PreviewBiddingIntradayOrderFeeAdjustedPricesRequestSchema, {}),
    { throwOnError: false },
  )
  const refetchState = useCallback(() => {
    void refetch()
  }, [refetch])
  return {
    state: resolveIntradayFeeState({ data, isPending, isError, failureCount }),
    refetch: refetchState,
  }
}
